import { NO_END, addDays, diffDay } from 'ha/helpers/hadate';
import { DateFlexibility } from '../constants';
import { FilterBuilder } from '../Types';

const dateToTSBuilder: FilterBuilder = ({
  startDate,
  endDate,
  advertiserId,
}) => {
  if (!startDate && !endDate && advertiserId) {
    return '';
  }

  const isShortRange = Boolean(
    startDate && endDate && diffDay(endDate, startDate) <= 2 * DateFlexibility,
  );

  const end = endDate
    ? isShortRange
      ? endDate // do not add flexible dates if user is searching for a short period
      : addDays(endDate, -DateFlexibility)
    : // If there is no end date specified, but there is a start date specified,
      // then the endDate should be greater than the startDate.
      startDate;

  const endDateTS = end ? new Date(end).getTime() / 1000 : '';
  const noEndDateTS = new Date(NO_END).getTime() / 1000;

  return endDateTS ? `(dateToTS>=${endDateTS} OR dateToTS=${noEndDateTS})` : '';
};

export default dateToTSBuilder;
